import React, {Component} from 'react';
import './NoticeItem.css';
import {Link} from "react-router-dom";
import {FormattedMessage} from "react-intl";

class NoticeItem extends Component {
    constructor(props) {
        super(props);
        this.state = {
            articleData:[]
        };

        this.getJapaneseDateFormatHomePage = this.getJapaneseDateFormatHomePage.bind(this);
    }

    getJapaneseDateFormatHomePage = (date) => {
        let d = new Date(date);

        let lang = "ja";

        let year = d.toLocaleString(lang, {year:'numeric'});
        let month = d.toLocaleString(lang, {month:'short'});
        let day = d.toLocaleString(lang, {day:'numeric'});

        return year + " " + month + " " + day + " ";
    };


    render() {
        return (
            <div>
                <div className="row no-padding">
                    <div className="notice-item-div">
                        <div className="col-md-3">
                        <span className="notice-item-text">
                             {this.getJapaneseDateFormatHomePage(this.props.article.createdDate)}
                            {/*2018.12.18*/}
                        </span>
                        </div>
                        <div className="col-md-2">
                            <text className="notice-item-button">
                                <FormattedMessage id="app.home-content.info-notice-btn"
                                                  defaultMessage="Important"
                                                  description=""/>

                            </text>
                        </div>
                        <div className="col-md-7">
                        <span className="notice-item-text">
                            <Link to={"/article/"+this.props.article.id} className="info-link">
                               {/* <FormattedMessage id="app.home-content.info-notice-description"
                                                  defaultMessage="The rigid two-layer board manufacturing standard has been updated."
                                                  description=""/>*/}
                                {this.props.article.title}
                                </Link>
                           {/* <Link to={{
                                pathname: "/article",
                                state: {
                                    articleData: this.props.article
                                }
                            }}>T{this.props.article.title}</Link>*/}
                        </span>
                        </div>
                    </div>

                </div>
                <div className="border-div"></div>
            </div>
        );
    }
}

export default NoticeItem;



// WEBPACK FOOTER //
// ./src/components/Site/HomeContent/InformationNotice/NoticeItem/NoticeItem.js